/*
  Allows us to extract a graphql query from AST and removes whitespace so that
  it is easily comparable in tests and doesn't fail because of whitespace differences
  like indentations
 */

export function getGraphQLString(doc) {
  return doc.loc.source && doc.loc.source.body.replace(/^\s+/gm, '').trim()
}
